import { faWarning } from '@fortawesome/pro-solid-svg-icons';
import { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { Chip } from '@sorare/core/src/atoms/ui/Chip';

type Props = {
  size: ComponentProps<typeof Chip>['size'];
};
export const DelayedReveal = ({ size = 'compact' }: Props) => {
  return (
    <Horizontal center>
      <Tooltip
        title={
          <FormattedMessage
            id="CardOverview.delayedRevealInfo.tooltip.v2"
            defaultMessage="The reveal is delayed until we receive the player’s photo from the club. In rare cases where no photo is provided, the reveal will not be possible."
          />
        }
      >
        <Chip color="yellow" size={size}>
          <FontAwesomeIcon icon={faWarning} />
          <LabelM color="var(--c-white)" bold>
            <FormattedMessage
              id="CardOverview.delayedRevealInfo"
              defaultMessage="Delayed reveal"
            />
          </LabelM>
        </Chip>
      </Tooltip>
    </Horizontal>
  );
};
